import { hazmat_override_event_type } from '@/@types/generated'
import { register } from './enum'

const HazmatOverrideEventTypeLabels: Record<
  hazmat_override_event_type,
  string
> = {
  [hazmat_override_event_type.CREATED]: 'Override applied',
  [hazmat_override_event_type.MODIFIED]: 'Override changed',
  [hazmat_override_event_type.REMOVED]: 'Override removed',
}

register<hazmat_override_event_type>(hazmat_override_event_type, (v) => {
  if (!v) return '—'
  return HazmatOverrideEventTypeLabels[v]
})
